import { createContext, useReducer, useEffect } from "react";
import { authReducer } from "./BCPAuthReducers";
import AuthObject from "./objects/BCPAuthObject";
import { datadogLogger } from "../utilities/DatadogLogger";
import tokenRefreshQueue from "../utilities/TokenRefreshQueue";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const authObject = new AuthObject();

  const [authState, dispatch] = useReducer(
    authReducer,
    authObject.initialToken()
  );

  useEffect(() => {
    dispatch({
      type: "initialise",
      payload: authObject
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      authState?.accessTokenString !== authObject?.accessTokenString ||
      authState?.idTokenString !== authObject?.idTokenString ||
      authState?.refreshTokenString !== authObject?.refreshTokenString
    ) {
      authObject.syncTokens(authState);
    }
    // eslint-disable-next-line
  }, [authState]);

  return (
    <AuthContext.Provider value={{ authState, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};

export async function currentAuthSession(options) {
  const authObject = new AuthObject();
  authObject.initialToken();
  if (!options?.ignoreExpired) {
    if (authObject?.idTokenExpired || authObject?.accessTokenExpired) {
      if (
        authObject?.refreshTokenString &&
        authObject?.refreshTokenString !== "undefined"
      ) {
        try {
          await tokenRefreshQueue.refreshTokens();

          // Reload the tokens after refresh
          authObject.initialToken();
        } catch (err) {
          datadogLogger.logForceLogout({
            reason: "token_refresh_failed",
            trigger: "session_refresh",
            error: err?.message,
            httpStatus: err?.status,
            apiEndpoint: "/oauth/token",
            component: "BCPAuthProvider"
          });
          authObject.removeTokens();
        }
      } else {
        datadogLogger.logForceLogout({
          reason: "refresh_token_missing",
          trigger: "session_validation",
          component: "BCPAuthProvider",
          sessionCorrupted: true
        });
        authObject.removeTokens();
      }
    }
  }
  return authObject;
}
